import {
  PanelContainer,
  useIsDesktop,
} from '@eCommerce/frontend-legacy-shared-library-native';
import {Flex, View} from 'native-base';
import React from 'react';

import SecurityMask from 'components/SecurityMask';

import {GatedModulePropTypes} from '..';

const GatedCompanionSummaryModule: React.FC<GatedModulePropTypes> = ({
  isLoading,
}) => {
  const isDesktop = useIsDesktop();

  return (
    <PanelContainer
      isLoading={isLoading}
      panelTitle="COMPANION NUMBER"
      icon="user-circle"
      testID="companion--info">
      <Flex mt={2} flexDirection={isDesktop ? 'row' : 'column'}>
        <View flexDirection="column" minW={'160px'}>
          <SecurityMask title="Travel Companion Number" showAsterisk />
        </View>
      </Flex>
    </PanelContainer>
  );
};

export default GatedCompanionSummaryModule;
